import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import moment from "moment"
import { Input, Empty, Descriptions, Button, DatePicker,message } from 'antd'
import { config } from '../../utils/config';
import { Page, Crud, Upload } from '../../components'

const { CrudTable, CrudForm, CrudFilter, CrudButtons } = Crud
const { SelectFile } = Upload;
export class Frui_zzzzPage extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { actions, user } = this.props
    const { getFrui_zzzzList } = actions
    let igasvID = JSON.parse(sessionStorage.getItem('user')).igasvID
    getFrui_zzzzList(igasvID)
  }
  compile = () => {
    const { chooseCurrentFruiZzzzModelShow } = this.props.actions
    chooseCurrentFruiZzzzModelShow(true)
  }
  get modalProps() {
    const { user, actions } = this.props
    const { userchooseCurrentFrui_zzzzModalVisible, submitFrui_zzzzPending, currentFrui_zzzz, frui_zzzzList } = user
    const { chooseCurrentFruiZzzzModelShow, submitFrui_zzzz, chooseCurrentFrui_zzzz, getFrui_zzzzList, uploadingXkzActions } = actions
    let editItem = frui_zzzzList !== undefined && frui_zzzzList !== null ? frui_zzzzList : {}
    // 许可证
    let imgXkz = []
    if (editItem.imageossLic) {
      imgXkz.push(editItem.imageossLic)
    }
    return {
      visible: userchooseCurrentFrui_zzzzModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submitFrui_zzzzPending,
      title: '编辑',
      centered: true,
      elements: [
        {
          key: "igasvID",
          label: "授权编号",
          initialValue: editItem.igasvID,
          widget: Input,
          disabled: true,
        },
        {
          key: "unitname",
          label: "单位名称",
          initialValue: editItem.unitname,
          widget: Input,
          disabled: true,
        },
        {
          key: "unitnameJc",
          label: "单位简称",
          initialValue: editItem.unitnameJc,
          widget: Input,
          disabled: true,
        },
        {
          key: "dateLic",
          label: "许可日期",
          initialValue: moment(editItem.dateLic),
          widget: DatePicker,
        },
        {
          key: "sLic",
          label: "许可开始时间",
          initialValue: moment(editItem.sLic),
          widget: DatePicker,
        },
        {
          key: "eLic",
          label: "许可结束时间",
          initialValue: moment(editItem.eLic),
          widget: DatePicker,
        },
        {
          key: "addressLic1",
          label: "许可地址1",
          initialValue: editItem.addressLic1,
          widget: Input,
        },
        {
          key: "addressLic2",
          label: "许可地址2",
          initialValue: editItem.addressLic2,
          widget: Input,
        },

        {
          key: "dmLic",
          label: "制造单位代码",
          initialValue: editItem.dmLic,
          widget: Input,
        },

        {
          key: "jgLic",
          label: "许可机关",
          initialValue: editItem.jgLic,
          widget: Input,
        },
        {
          key: "noLic",
          label: "许可证号",
          initialValue: editItem.noLic,
          widget: Input,
        },
        {
          key: "numLic",
          label: "制造单位代码(数字)",
          initialValue: editItem.numLic,
          widget: Input,
        },

        {
          key: "typeLic",
          label: "许可类别",
          initialValue: editItem.typeLic,
          widget: Input,
        },
        {
          key: "yearLic",
          label: "有效年度",
          initialValue: editItem.yearLic,
          widget: Input,
        },
        {
          key: "imageossLic",
          label: "许可证",
          initialValue: editItem === undefined ? [] : imgXkz,
          widget: SelectFile,
        },
      ],
      onOk: ress => {
        console.log(ress)
        let dateLic = ''
        let sLic = ''
        let eLic = ''
        if (ress.dateLic) {
          dateLic = ress.dateLic.format('YYYY-MM-DD')
        }
        if (ress.sLic) {
          sLic = ress.sLic.format('YYYY-MM-DD')
        }
        if (ress.eLic) {
          eLic = ress.eLic.format('YYYY-MM-DD')
        }
      //   let image = ''
      //  image =  ress.imageossLic.join(',')
        let params = {
          addressLic1:ress.addressLic1,
          addressLic2:ress.addressLic2,
          dateLic:dateLic,
          dmLic:ress.dmLic,
          eLic:eLic,
          igasvID:ress.igasvID,
          jgLic:ress.jgLic,
          noLic:ress.noLic,
          numLic:ress.numLic,
          sLic:sLic,
          typeLic:ress.typeLic,
          unitname:ress.unitname,
          unitnameJc:ress.unitnameJc,
          yearLic:ress.yearLic,
          imageossLic:imgXkz
        }
        submitFrui_zzzz(params).then(data => {
          console.log(data)
          let params1 = new FormData()
          params1.append('file',ress.imageossLic)
          uploadingXkzActions(params1,ress.igasvID).then((res) => {
          }) 
          console.log(params)
          chooseCurrentFrui_zzzz(params)
          chooseCurrentFruiZzzzModelShow(false)
          getFrui_zzzzList(params.igasvID)
        })
      },
      onCancel() {
        chooseCurrentFruiZzzzModelShow(false);
      },
    }
  }
  handleXkzImage = (e) => {
    const { actions } = this.props
      window.open(`${config.attachUrl}${e}`)
  }
  render() {
    const { frui_zzzzList } = this.props.user
    if (frui_zzzzList === undefined) {
      return <Empty />
    }
    return (
      <Page inner>
        <Descriptions bordered>
          <Descriptions.Item label="授权编号">{frui_zzzzList.igasvID !== undefined && frui_zzzzList.igasvID !== null ? frui_zzzzList.igasvID : ''}</Descriptions.Item>
          <Descriptions.Item label="单位简称">{frui_zzzzList.unitnameJc !== undefined && frui_zzzzList.unitnameJc !== null ? frui_zzzzList.unitnameJc : ''}</Descriptions.Item>
          <Descriptions.Item label="单位名称">{frui_zzzzList.unitname !== undefined && frui_zzzzList.unitname !== null ? frui_zzzzList.unitname : ''}</Descriptions.Item>
          <Descriptions.Item label="许可证号">{frui_zzzzList.noLic !== undefined && frui_zzzzList.noLic !== null ? frui_zzzzList.noLic : ''}</Descriptions.Item>
          <Descriptions.Item label="许可日期">{frui_zzzzList.dateLic !== undefined && frui_zzzzList.dateLic !== null ? frui_zzzzList.dateLic : ''}</Descriptions.Item>
          <Descriptions.Item label="制造单位代码">{frui_zzzzList.dmLic !== undefined && frui_zzzzList.dmLic !== null ? frui_zzzzList.dmLic : ''}</Descriptions.Item>
          <Descriptions.Item label="许可结束时间">{frui_zzzzList.eLic !== undefined && frui_zzzzList.eLic !== null ? frui_zzzzList.eLic : ''}</Descriptions.Item>
          <Descriptions.Item label=" 许可开始时间">{frui_zzzzList.sLic !== undefined && frui_zzzzList.sLic !== null ? frui_zzzzList.sLic : ''}</Descriptions.Item>
          <Descriptions.Item label="有效年度">{frui_zzzzList.yearLic !== undefined && frui_zzzzList.yearLic !== null ? frui_zzzzList.yearLic : ''}</Descriptions.Item>
          <Descriptions.Item label="制造单位代码(数字)">{frui_zzzzList.numLic !== undefined && frui_zzzzList.numLic !== null ? frui_zzzzList.numLic : ''}</Descriptions.Item>
          <Descriptions.Item label="许可类别">{frui_zzzzList.typeLic !== undefined && frui_zzzzList.typeLic !== null ? frui_zzzzList.typeLic : ''}</Descriptions.Item>
          <Descriptions.Item label="许可地址1">{frui_zzzzList.addressLic1 !== undefined && frui_zzzzList.addressLic1 !== null ? frui_zzzzList.addressLic1 : ''}</Descriptions.Item>
          <Descriptions.Item label="许可地址2">{frui_zzzzList.addressLic2 !== undefined && frui_zzzzList.addressLic2 !== null ? frui_zzzzList.addressLic2 : ''}</Descriptions.Item>
          <Descriptions.Item label="许可机关">{frui_zzzzList.jgLic !== undefined && frui_zzzzList.jgLic !== null ? frui_zzzzList.jgLic : ''}</Descriptions.Item>
          <Descriptions.Item label="许可证" span={4}>
            <a onClick={() => 
            this.handleXkzImage(frui_zzzzList.imageossLic,)}>
            {frui_zzzzList.imageossLic !== undefined && frui_zzzzList.imageossLic !== null ?   frui_zzzzList.imageossLic : ''}
            </a>
          </Descriptions.Item>
        </Descriptions>
        <Button onClick={this.compile} className='button' type="primary">编辑</Button>
        <div>
          <CrudForm {...this.modalProps} />
        </div>
      </Page>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Frui_zzzzPage);


// WEBPACK FOOTER //
// ./src/features/user/Frui_zzzzPage.js